
import dashboard from './dashboard';

// ==============================|| MENU ITEMS ||============================== //

const getMenuItems = () => {
  return {
    items: [dashboard]
  }
}

export default getMenuItems
